import { XerTable, XerTables } from './xerTypes'

/**
 * Parse a Primavera P6 .xer file into named tables.
 * Format: ERMHDR header, then %T (table), %F (fields), %R (rows).
 */
export function parseXer(content: string): XerTables {
  const tables: XerTables = {}
  let currentTable: string | null = null
  let currentFields: string[] = []
  let currentRows: string[][] = []

  const flush = () => {
    if (currentTable) {
      tables[currentTable] = {
        fields: currentFields,
        rows: currentRows,
      }
    }
  }

  const lines = content.split(/\r?\n/)
  for (const rawLine of lines) {
    if (!rawLine || rawLine.startsWith('ERMHDR')) {
      continue
    }

    if (rawLine.startsWith('%T\t') || rawLine === '%T') {
      flush()
      currentTable = rawLine.slice(3).trim()
      currentFields = []
      currentRows = []
      continue
    }

    if (!currentTable) {
      continue
    }

    if (rawLine.startsWith('%F\t') || rawLine.startsWith('%F')) {
      currentFields = rawLine.slice(3).split('\t')
      continue
    }

    if (rawLine.startsWith('%R\t') || rawLine.startsWith('%R')) {
      currentRows.push(rawLine.slice(3).split('\t'))
    }
  }

  flush()
  return tables
}

export function getFieldIndex(table: XerTable, fieldName: string): number {
  return table.fields.indexOf(fieldName)
}

export function getRowValue(
  table: XerTable,
  row: string[],
  fieldName: string,
): string {
  const index = getFieldIndex(table, fieldName)
  if (index < 0 || index >= row.length) {
    return ''
  }
  return row[index] ?? ''
}
